// services/pdfService.js
export class PdfService {
  // -----------------------------
  // PDF fetching with authentication - NOW RETURNS DIRECT URL
  // -----------------------------
  static async getPdf(documentTitle) {
    if (!documentTitle) {
      throw new Error('Document title is required');
    }

    // If it's the old default path, use "je" instead
    if (documentTitle === "/j.pdf") {
      console.warn('Using default document "je" instead of "/j.pdf"');
      documentTitle = "je";
    }

    try {
      console.log(`📥 Fetching PDF: ${documentTitle}`);
      
      // Get Firebase token from localStorage
      const token = sessionStorage.getItem('token');
      
      if (!token) {
        throw new Error('Authentication required. Please log in.');
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/pdf/${encodeURIComponent(documentTitle)}`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      
      if (response.status === 401) {
        localStorage.removeItem("token");
        throw new Error('Authentication expired. Please log in again.');
      }
      
      if (response.status === 403) {
        throw new Error('You do not have permission to access this PDF.');
      }
      
      if (response.status === 404) {
        throw new Error('PDF not found. It may have been deleted or you may not have access.');
      }
      
      if (!response.ok) {
        throw new Error(`Failed to fetch PDF: ${response.status} ${response.statusText}`);
      }

      // ✅ Now we get a JSON response with the Cloudflare URL
      const data = await response.json();
      
      if (!data.success || !data.pdfUrl) {
        throw new Error('Invalid response from server: No PDF URL received');
      }

      console.log('✅ PDF URL received from backend:', data.pdfUrl.substring(0, 100) + '...');
      
      // ✅ Return the direct Cloudflare URL
      return data.pdfUrl;
      
    } catch (error) {
      console.error('❌ PDF Service Error:', error);
      throw error;
    }
  }

  // ✅ No need for blob cleanup anymore - Cloudflare URLs don't need cleanup
  static cleanupPdf(url) {
    // Nothing to cleanup for direct URLs
    console.log('🧹 PDF cleanup called (no action needed for Cloudflare URLs)');
  }

  // Optional: Method to get document metadata
  static async getPdfMetadata(documentTitle) {
    try {
      const pdfUrl = await this.getPdf(documentTitle);
      
      // The backend now returns document data along with the URL
      // You might want to enhance this to return both URL and metadata
      return {
        url: pdfUrl,
        // Add other metadata as needed
      };
    } catch (error) {
      console.error('Error getting PDF metadata:', error);
      throw error;
    }
  }
}